<fui-icon [height]="9" [icon]="'success'" [width]="13"></fui-icon>
